<template>
  <b-card class="rounded-lg">
    <report-header
      :title="$t('ledger_rep_profit')"
      :scope-label="scopeLabel"
      :can-company="canCompany"
      :company="company"
      @company="company = $event; load()"
      @print="printReport"
    />
    <div class="d-flex flex-wrap mb-1">
      <b-form-input v-model="from" type="date" class="mr-50 mb-50 ledger-report-date" />
      <b-form-input v-model="to" type="date" class="mr-50 mb-50 ledger-report-date" />
      <b-button variant="primary" size="sm" @click="load">{{ $t('ledger_assets_load') }}</b-button>
    </div>
    <div v-if="loading" class="text-center py-3"><b-spinner /></div>
    <template v-else-if="report">
      <h5>{{ $t('ledger_cost_revenue') }}</h5>
      <div v-for="row in report.revenue || []" :key="row.code" class="d-flex justify-content-between">
        <span>{{ row.code }} {{ nameOf(row) }}</span>
        <span class="ledger-num">{{ money(row.amount) }}</span>
      </div>
      <div v-for="group in report.expense_groups || []" :key="group.group" class="mt-1">
        <strong>{{ group.label_ar || group.label }}</strong>
        <span class="ledger-num"> {{ money(group.total) }}</span>
      </div>
      <div v-if="report.totals" class="mt-1 font-weight-bold ledger-num">
        {{ $t('ledger_rep_net') }} {{ money(report.totals.net_profit) }}
        ({{ report.totals.net_margin_percent }}%)
      </div>
    </template>
  </b-card>
</template>

<script>
import { BCard, BFormInput, BButton, BSpinner } from 'bootstrap-vue'
import { getProfitPosition } from '@/api/accounting/financialReports'
import { oneFrom } from '@/utils/ledger'
import ReportHeader from './ReportHeader.vue'
import reportMixin from './reportMixin'

export default {
  name: 'ProfitPosition',
  components: { BCard, BFormInput, BButton, BSpinner, ReportHeader },
  mixins: [reportMixin],
  created() {
    this.applyRouteQuery()
  },
  mounted() { this.load() },
  watch: {
    '$route.query': function onQuery() {
      this.applyRouteQuery()
      this.load()
    },
  },
  methods: {
    applyRouteQuery() {
      const query = this.$route.query || {}
      const hasFrom = typeof query.from === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(query.from)
      const hasTo = typeof query.to === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(query.to)
      if (hasFrom) this.from = query.from
      if (hasTo) this.to = query.to
      if (hasFrom || hasTo || query.scope) this.company = query.scope === 'company' && this.canCompany
    },
    nameOf(row) {
      return this.$i18n.locale === 'en' ? (row.name_en || row.name) : (row.name || row.name_en)
    },
    async load() {
      this.loading = true
      try {
        const res = await getProfitPosition({ from: this.from, to: this.to, ...this.scopeParams })
        this.report = oneFrom(res)
      } catch (error) {
        this.toastError(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.ledger-num { font-variant-numeric: tabular-nums; }
.ledger-report-date { max-width: 11rem; }
</style>
